import { render, staticRenderFns } from "./RelatedPosts.vue?vue&type=template&id=5b6e93af&"
import script from "./RelatedPosts.vue?vue&type=script&lang=js&"
export * from "./RelatedPosts.vue?vue&type=script&lang=js&"
import style0 from "./RelatedPosts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports